import React, { useEffect, useState, Suspense } from "react";
import { useSearchParams } from "react-router-dom";
import navigationContext from "../../contexts/navigationsContext";
import { navigations } from "../../Data/navigation.json";
import useToggle from "../../Hooks/useToggle";
import BackToTop from "../Helpers/BackToTop";
import Drawer from "../Mobile/Drawer";
import Footer from "../Partials/Footers/HomeOne/Footer";
import HeaderOne from "../Partials/Headers/HeaderOne";
import { getBannerIMG, getLotteryData } from "../../services/HomeServices";
import { isImageOrVideo } from "../../lib/constant";
import { getUserId } from "../../lib/constant";
import { motion } from "framer-motion";
import DrawModule from "./DrawModule";
import CategoryNavigation from "./CategoryNavigation";
import SubcategoryNavigation from "./SubcategoryNavigation";
import "./HomePage.css";

const WinnerSection = React.lazy(() => import("./WinnerSection"));

const BannerPoster = React.lazy(() =>
  import("../Partials/Headers/HeaderOne/BannerPoster")
);

const ProductModule = React.lazy(() => import("./ProductModule"));

const HomeOne = () => {
  const navigationData = navigations;
  const [drawer, setDrawer] = useToggle(false);
  const [bannerImage, setbannerImage] = useState([]);
  const [featuredDraw, setFeaturedDraw] = useState(null);
  const [searchParams] = useSearchParams();

  const categoryId = searchParams.get("category_id");
  const subcategoryId = searchParams.get("subcategory_id");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    getBannerImage();
    getFeaturedDraw();
  }, []);

  const getBannerImage = async () => {
    try {
      const response = await getBannerIMG();
      const array = response?.data?.data?.map((a) => ({
        ...a,
        isImage: isImageOrVideo(a?.image) === "image",
      })) || [];
      setbannerImage(array);
    } catch (error) {
      console.error("Error fetching banner:", error);
      setbannerImage([]);
    }
  };

  const getFeaturedDraw = async () => {
    try {
      const response = await getLotteryData(1, 1, getUserId());
      const draws = response?.data?.data || [];
      if (draws.length > 0) {
        setFeaturedDraw(draws[0]);
      }
    } catch (error) {
      console.error("Error fetching featured draw:", error);
    }
  };

  const LoadingFallback = () => (
    <div className="loading-container">
      <div className="modern-spinner"></div>
    </div>
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      style={{ overflow: "hidden" }}
    >
      <Drawer
        drawer={drawer}
        action={setDrawer.toggle}
        navigationData={navigationData}
      />

      <navigationContext.Provider value={{ navigationData }}>
        <HeaderOne drawerAction={setDrawer.toggle} />
      </navigationContext.Provider>

      <Suspense fallback={<LoadingFallback />}>
        <BannerPoster data={bannerImage} featuredDraw={featuredDraw} />
      </Suspense>

      <CategoryNavigation />

      {categoryId && <SubcategoryNavigation categoryId={categoryId} />}

      <Suspense fallback={<LoadingFallback />}>
        <ProductModule subcategoryId={subcategoryId} />
      </Suspense>

      <Suspense fallback={<LoadingFallback />}>
        <DrawModule />
      </Suspense>

      <Suspense fallback={<LoadingFallback />}>
        <WinnerSection />
      </Suspense>

      <Footer />
      <BackToTop />
    </motion.div>
  );
};

export default HomeOne;
